import { takeLatest, all } from "redux-saga/effects";
import { UserTypes } from "../store/user/Actions";
import {
  classLinkLogin,
  userLogin,
  refreshToken,
  getCourseListForStudent,
  getChapterListForStudent,
  getLessonFoldersForStudent,
  getAssignmentDataForStudent,
  getAssignmentDataSummaryForStudent,
  getLessonUnitDetailsForStudent,
  saveActivityForStudent,
  unlockOfflineLessonUnit,
  unlockOfflineCourse,
  getActivityForStudent,
  setExerciseList,
  setPreviousExerciseList,
  getUpcomingAssignmentForStudent,
  changeLoggedOutStatus,
  forgotPasswordStudent,
  getLessonFolderBySubject,
  getLessonUnitsByFolder,
  getCourseSummaryAnalyticsReport,
  getLessonPodSummaryAnalyticsReport,
  getLessonPodActivityAnalyticsReport,
  getContainedActivityForStudent,
  chatChallengeMe,
} from "./UserSaga";

export default function* root() {
  yield all([
    takeLatest(UserTypes.CLASS_LINK_LOGIN, classLinkLogin),
    takeLatest(UserTypes.USER_LOGIN, userLogin),
    takeLatest(UserTypes.REFRESH_TOKEN, refreshToken),
    takeLatest(UserTypes.GET_COURSE_LIST_FOR_STUDENT, getCourseListForStudent),
    takeLatest(
      UserTypes.GET_CHAPTER_LIST_FOR_STUDENT,
      getChapterListForStudent
    ),
    takeLatest(
      UserTypes.GET_LESSON_FOLDERS_FOR_STUDENT,
      getLessonFoldersForStudent
    ),
    takeLatest(
      UserTypes.GET_ASSIGNMENT_DATA_FOR_STUDENT,
      getAssignmentDataForStudent
    ),
    takeLatest(
      UserTypes.GET_ASSIGNMENT_DATA_SUMMARY_FOR_STUDENT,
      getAssignmentDataSummaryForStudent
    ),
    takeLatest(
      UserTypes.GET_LESSON_UNIT_DETAILS_FOR_STUDENT,
      getLessonUnitDetailsForStudent
    ),
    takeLatest(UserTypes.SAVE_ACTIVITY_FOR_STUDENT, saveActivityForStudent),
    takeLatest(UserTypes.UNLOCK_OFFLINE_LESSON_UNIT, unlockOfflineLessonUnit),
    takeLatest(UserTypes.UNLOCK_OFFLINE_COURSE, unlockOfflineCourse),

    takeLatest(UserTypes.GET_ACTIVITY_FOR_STUDENT, getActivityForStudent),
    takeLatest(UserTypes.SET_EXERCISE_LIST, setExerciseList),
    takeLatest(UserTypes.SET_PREVIOUS_EXERCISE_LIST, setPreviousExerciseList),
    takeLatest(
      UserTypes.GET_UPCOMING_ASSIGNMENT_FOR_STUDENT,
      getUpcomingAssignmentForStudent
    ),
    takeLatest(UserTypes.CHANGE_LOGGED_OUT_STATUS, changeLoggedOutStatus),
    takeLatest(UserTypes.FORGOT_PASSWORD_STUDENT, forgotPasswordStudent),
    takeLatest(
      UserTypes.GET_LESSON_FOLDER_BY_SUBJECT,
      getLessonFolderBySubject
    ),
    takeLatest(UserTypes.GET_LESSON_UNITS_BY_FOLDER, getLessonUnitsByFolder),
    takeLatest(
      UserTypes.GET_COURSE_SUMMARY_ANALYTICS_REPORT,
      getCourseSummaryAnalyticsReport
    ),
    takeLatest(
      UserTypes.GET_LESSON_POD_SUMMARY_ANALYTICS_REPORT,
      getLessonPodSummaryAnalyticsReport
    ),
    takeLatest(
      UserTypes.GET_LESSON_POD_ACTIVITY_ANALYTICS_REPORT,
      getLessonPodActivityAnalyticsReport
    ),

    takeLatest(
      UserTypes.GET_CONTAINED_ACTIVITY_FOR_STUDENT,
      getContainedActivityForStudent
    ),
    takeLatest(UserTypes.CHAT_CHALLENGE_ME, chatChallengeMe),
  ]);
}
